import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/core/ajax.service";
import * as i2 from "Angular/services/core/urls.service";
export class RiskToleranceQuestionnaireService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    createNewAssessment(client_name, name, questionnaire_id, is_async, target_folder, registration_id, client_email) {
        const url = this.urlsService.RTQ.NEW_ASSESSMENT;
        const params = {
            questionnaire_id,
            client_name,
            name,
            is_async,
        };
        if (target_folder !== null) {
            params.targetFolder = target_folder;
        }
        if (registration_id) {
            params.registration_id = registration_id;
        }
        if (client_email) {
            params.client_email = client_email;
        }
        return this.ajaxService.postJsonDataObserveBody(url, params);
    }
    saveAnswer(item_id, selected_choice_id, answer, validate_user) {
        const url = this.urlsService.RTQ.SAVE_ANSWER;
        const params = {
            item_id,
            selected_choice_id,
            answer,
            validate_user,
        };
        return this.ajaxService.postJsonDataObserveBody(url, params);
    }
    assignRiskProfile(assessment_id, risk_profile_id, reassign_note = null) {
        const url = this.urlsService.RTQ.ASSIGN_RISK_PROFILE;
        const params = {
            assessment_id,
            risk_profile_id,
            reassign_note,
        };
        return this.ajaxService.postJsonDataObserveBody(url, params);
    }
    checkActiveAssessmentForRegistration(registration_id) {
        const url = this.urlsService.RTQ.ACTIVE_ASSESSMENT;
        return this.ajaxService.getDataObserveBody(url, { registration_id });
    }
    getRiskToleranceQuestionnairesList() {
        const url = this.urlsService.RTQ.ACTIVE_QUESTIONNAIRE_COLLECTION;
        return this.ajaxService.getDataObserveBody(url);
    }
    duplicateQuestionnaire(questionnaireId, name, target_folder) {
        const url = this.urlsService.getUrl(this.urlsService.RTQ.DUPLICATE, {
            questionnaireId,
        });
        const params = { name };
        if (target_folder !== null) {
            params.targetFolder = target_folder;
        }
        return this.ajaxService.postJsonDataObserveBody(url, params);
    }
    createRTQ(name, target_folder) {
        const url = this.urlsService.RTQ.NEW_QUESTIONNAIRE;
        const params = {
            name,
        };
        if (target_folder !== null) {
            params.targetFolder = target_folder;
        }
        return this.ajaxService.postJsonDataObserveBody(url, params);
    }
    mapRiskProfiles(questionnaireId, score_ranges) {
        const url = this.urlsService.getUrl(this.urlsService.RTQ.MAP_RISK_PROFILES, {
            questionnaireId,
        });
        const params = {
            score_ranges,
        };
        return this.ajaxService.postJsonDataObserveBody(url, params);
    }
    saveQuestionnaireItem(questionnaireId, item) {
        const url = this.urlsService.getUrl(this.urlsService.RTQ.SAVE_QUESTIONNAIRE_ITEM, {
            questionnaireId,
        });
        return this.ajaxService.postJsonDataObserveBody(url, item);
    }
    deleteQuestionnaireItem(itemId) {
        const url = this.urlsService.getUrl(this.urlsService.RTQ.DELETE_QUESTIONNAIRE_ITEM, {
            itemId,
        });
        return this.ajaxService.deleteDataObserveBody(url);
    }
    orderQuestionItems(questionnaireId, ordered_item_ids) {
        const url = this.urlsService.getUrl(this.urlsService.RTQ.ORDER_QUESTIONNAIRE_ITEMS, {
            questionnaireId,
        });
        const params = {
            ordered_item_ids,
        };
        return this.ajaxService.postJsonDataObserveBody(url, params);
    }
}
RiskToleranceQuestionnaireService.ɵfac = function RiskToleranceQuestionnaireService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RiskToleranceQuestionnaireService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
RiskToleranceQuestionnaireService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RiskToleranceQuestionnaireService, factory: RiskToleranceQuestionnaireService.ɵfac, providedIn: 'root' });
